import { getCity,getAllCityInfo } from "@/apis/common";
import { getStores } from "@/apis/controls/shop.js";
export default {
    strict: true,
    namespaced: true,
    state: {
        allCity:[],
        city: [],
        stores: []
    },
    mutations: {
        // // 保存城市信息
        // saveCity: (state, data) => {
        //     state.city = data
        // },
        // 保存门店信息
        saveStores: (state, data) => {
            state.stores = data
        },
        saveAllCity:(state,data) => {
            state.allCity = data
        }
    },
    actions: {
        async getCity({ commit }) {
            let res = await getAllCityInfo()
            // console.log('所有地址信息11',res)
            commit('saveAllCity', res)
        }
    },
    getters: {
        // 所有省
        allProvince:(state) => {
            return state.allCity.filter(item => item.level === 1)
        },
        // 所有市
        allCity:(state) => {
            return state.allCity.filter(item => item.level === 2)
        },
        // 所有区
        allArea:(state) => {
            return state.allCity.filter(item => item.level === 3)
        },
        // filterDisableProvince:(state,getters) => {
        //     return getters.allProvince.filter(item.enabled === 1)
        // },
        filterDisableCity:(state,getters) => {
            return getters.allCity.filter(item => item.enabled === 1)
        },
        // filterDisableArea:(state,getters) => {
        //     return getters.allArea.filter(item.enabled === 1)
        // },
        // // 过滤禁用的门店
        // filterDisableCity: (state) => {
        //     return state.city.filter(item => item.enabled === 1)
        // },
        // originalCity: state => state.city,
        stores: state => state.stores
    }
}


// WEBPACK FOOTER //
// ./src/store/storePick.js